/**
 * @param node {Node | string}
 * @return {void}
 */
module.exports = function appendToBody(...node) {
    window.document.body.append(...node);
}